import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { GridOptions } from 'ag-grid-community';
import { AlertService, AuthenticationService, UserService } from '../_services';
import * as moment from 'moment';
import { DatepickerOptions } from 'ng2-datepicker';
import * as frLocale from 'date-fns/locale/en';
@Component({
  selector: 'app-addtasktime',
  templateUrl: './addtasktime.component.html',
  styleUrls: ['./addtasktime.component.scss']
})
export class AddTaskTimeComponent implements OnInit, AfterViewInit {
  allocatedCallForm: FormGroup;
  private context;
  private domLayout;

  private lastindexofgrid: number = 0;
  private totalrawcount: number = 0;
  private Extensions = [];
  private isFromDns: string = "";
  private userID: string = "";
  private frameworkComponents;
  private isgraybackground: boolean = false;
  private rowHeight;
  private CommentContent: string = "";
  private DeviceList: any = [];
  private DirectionList: any = [];
  private HoursList: any = [];
  private MinuteList: any = [];

  private mdlAccount: string = "";
  private mdlAccountId: string = "";
  private mdlPreviousAccount: string = "";
  private mdlPreviousAccountId: string = "";
  private themeWrapper = document.querySelector('body');
  private AccountList: any = [];
  private AccountSelectList: any;
  private tempSelecteAccountID: string = "";
  private tempSelecteAccount: string = "";
  private mdlTotalCost: any;
  private mdlDurationValue: any = 0;
  private mdlRate: any;
  private mdlComment: string = "";
  private mdlbillable: boolean = false;

  //datetime formate
  fromoptions: DatepickerOptions = {
    minYear: 1970,
    maxYear: 2099,
    displayFormat: 'YYYY-MM-DD',
    barTitleFormat: 'YYYY-MM-DD',
    dayNamesFormat: 'dd',
    firstCalendarDay: 0,
    locale: frLocale,
    //minDate: new Date(Date.now()), // Minimal selectable date
    //maxDate: new Date(Date.now()),  // Maximal selectable date
    barTitleIfEmpty: 'YYYY-MM-DD',
    placeholder: 'YYYY-MM-DD', // HTML input placeholder attribute (default: '')
    addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    addStyle: {},
    fieldId: 'searchFromDate', // Optional, value to pass to [ngStyle] on the input field
    useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown 
  };
  tooptions: DatepickerOptions = {
    minYear: 1970,
    maxYear: 2099,
    displayFormat: 'YYYY-MM-DD',
    barTitleFormat: 'YYYY-MM-DD',
    dayNamesFormat: 'dd',
    firstCalendarDay: 0,
    locale: frLocale,
    //minDate: new Date(Date.now()), // Minimal selectable date
    //maxDate: new Date(Date.now()),  // Maximal selectable date
    barTitleIfEmpty: 'YYYY-MM-DD',
    placeholder: 'YYYY-MM-DD', // HTML input placeholder attribute (default: '')
    addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    fieldId: 'searchtoDate',
    useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown 
  };
  defaultColDef = { resizable: true, autoHeight: true };

  selectdevicekey = "value";
  selectHourskey = "value";
  selectMinutekey = "value";

  selectdirectionkey = "value";

  //Extention Dropdown 
  selectextkey = "value";
  //DropDown Style Class
  styleGuide: {
    caretClass: 'caret',
    selectBoxClass: 'dropdown-wrapper',
    selectMenuClass: 'dropdown',
    optionsClass: 'option'
  }

  currentDate = new Date(2021, 1, 1);
  dateFormat = 'HH:MM';


  constructor(private formBuilder: FormBuilder, private route: ActivatedRoute,
    private router: Router, private userservice: UserService, private alertService: AlertService) {
    this.HoursList = [];
    this.MinuteList = [];

    this.allocatedCallForm = this.formBuilder.group({
      ddlDirection: [{ "key": "", "value": "Direction" }],
      ddlDevice: [{ "key": "", "value": "Device" }],
      ddlHours: [''],
      ddlMinute: [''],
      txtDate: ['', Validators.required],
      txtTime: [new Date(2021, 1, 1), Validators.required],
      txtBillableNonBillable: ['Billable'],
      txtAccount: [''],
      txtRate: [''],
      txtTotal: [''],
      txtComment: [''],
      txtTimeDuplicate: [''],
    });

    this.userservice.GetListAccounts(localStorage.getItem("user")).subscribe(
      response => {
        let data = response;
        console.log("accountlist");
        console.log(data);
        if (data["StatusCode"] == "200") {
          this.AccountList = data["Data"];
        }
      });

    this.context = { componentParent: this };
    for (var i = 0; i < 24; i++) {
      this.HoursList.push({
        "key": i.toString(), "value": ("0" + i.toString()).slice(-2)
      })
    }
    for (var i = 0; i < 60; i++) {
      this.MinuteList.push({
        "key": i.toString(), "value": ("0" + i.toString()).slice(-2)
      })
    }
  }

  ngOnInit() {
    if (localStorage.getItem("PrimaryColor") && localStorage.getItem("SecondaryColor")) {
      //this.isFromDns=localStorage.getItem("isfromDns")
      this.isgraybackground = true;
    }
    this.userID = localStorage.getItem("user");

    this.Extensions = [];
    this.Extensions = [{ "key": "", "value": "Ext" }];
    if (localStorage.getItem('Extensions')) {
      let tempextention = localStorage.getItem('Extensions').split(',');
      if (tempextention.length > 0) {
        tempextention.forEach((value, key, i) => {
          this.Extensions.push({ "key": value.trim(), "value": value.trim() })
        });
      }
    }
    this.getdevice();
    this.getdirection();
    debugger;
    if (localStorage.getItem('rate')) {
      this.mdlRate = localStorage.getItem('rate').replace(',', '.');
    }

  }


  // convenience getter for easy access to form fields
  get f() { return this.allocatedCallForm.controls; }
  //from date change event
  fromchange(event) {

    this.tooptions = {
      minYear: 1970,
      maxYear: 2099,
      displayFormat: 'YYYY-MM-DD',
      barTitleFormat: 'YYYY-MM-DD',
      dayNamesFormat: 'dd',
      firstCalendarDay: 0,
      locale: frLocale,
      minDate: this.f.searchFromDate.value,
      barTitleIfEmpty: 'YYYY-MM-DD',
      placeholder: 'YYYY-MM-DD', // HTML input placeholder attribute (default: '')
      addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
      addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
      fieldId: 'searchtoDate',
      useEmptyBarTitle: false,
    }
    if (this.f.searchFromDate.value != "") {
      let ele = (<HTMLInputElement>document.getElementById('searchFromDate'));
      ele.value = moment(this.f.searchFromDate.value).format("YYYY-MM-DD");
    }
  }


  ExpandComment(cell) {
    this.CommentContent = "";
    if (cell.Comment) {
      this.CommentContent = cell.Comment;
      document.getElementById("btncommentmodelpopup").click();
    }
  }
  ngAfterViewInit() {


  }

  getdirection() {

    this.userservice.DirectionList(localStorage.getItem('ServerId')).subscribe(
      response => {
        let data = response;
        console.log(response);
        // this.DirectionList=[{ "key": "", "value": "Direction" }];
        if (data["StatusCode"] == "200") {
          let DirectionData = data["Data"];

          if (DirectionData.length > 0) {
            DirectionData.forEach((value, key, i) => {
              this.DirectionList.push({ "key": value.trim(), "value": value.trim() })
            });

          }

        }
      });
  }

  getdevice() {
    this.DeviceList = [];
    this.DeviceList.push({ "key": "Mobile Call", "value": "Mobile Call" })
    this.DeviceList.push({ "key": "Word", "value": "Word" })
    this.DeviceList.push({ "key": "Excel", "value": "Excel" })
    this.DeviceList.push({ "key": "Email", "value": "Email" })
    this.DeviceList.push({ "key": "Whatsapp", "value": "Whatsapp" })
    this.DeviceList.push({ "key": "Other", "value": "Other" })
    // this.userservice.DeviceList(localStorage.getItem('ServerId')).subscribe(
    //   response => {
    //     // this.DeviceList = [{ "key": "", "value": "Task Type" }];

    //     let data = response;
    //     if (data["StatusCode"] == "200") {
    //       let DeviceData = data["Data"];

    //       if (DeviceData.length > 0) {
    //        DeviceData.forEach((value, key, i) => {
    //         this.DeviceList.push({ "key": value.trim(), "value": value.trim() })
    //       });
    //       }
    //     }
    //   });
  }

  AllocateTaskTime_Click() {
    if (1 == 1) {
      this.alertService.showNotification('error', "Add comment.")
    }
    else {
      let recordid: string = String("");
      let unallocatecall = {
        RecordID: recordid + ",",
        UserID: localStorage.getItem("user"),
        AccountID: null,
        Rate: 0,
        Comment: "",
        Billable: false,
        Personal: true,
        ServerID: "" + ","
      };
      this.userservice.UpdateCall(unallocatecall)
        .subscribe(
          data => {
            if (data["StatusCode"] == "200") {
            }
            else {
              this.alertService.showNotification('error', data["Message"])
            }
          });
    }
  }

  SaveAllocatedCall() {
    debugger;
    // stop here if form is invalid

    // if (this.allocatedCallForm.invalid) {
    //   this.alertService.showNotification('error', "All fields must be required, please fill and submit again.")
    //   return; 
    // }    
    console.log(this.f);

    if (this.f.txtBillableNonBillable.value.toLowerCase() == "Billable".toLowerCase()) {
      this.mdlbillable = true;

    }
    else {
      this.mdlbillable = false;

    }

    let addTaskTime = {
      RecordID: null,
      AccountID: this.mdlAccountId,
      Rate: this.mdlbillable ? this.mdlRate : 0,
      Comment: this.mdlComment,
      Duration: this.mdlDurationValue,
      Billable: this.mdlbillable,
      Device: this.f.ddlDevice.value["value"],
      Direction: this.f.ddlDirection.value["value"],
      UserID: localStorage.getItem("user"),
      RecordDate: this.f.txtDate.value,
      AllocatedDate: new Date(),
      ServerID: localStorage.getItem('ServerId')
    };
    this.userservice.AddTaskTime(addTaskTime)
      .subscribe(
        data => {
          if (data["StatusCode"] == "200") {

            this.ClearData();
            this.router.navigate(['/allocatehistory']);
            //this.alertService.showNotification('success', "Record has been added.")
          }
          else {
            this.alertService.showNotification('error', data["Message"])
          }
        });

  }

  //to date change event
  tochange(event) {
    debugger;
    if (this.f.txtDate.value != "") {
      let ele = (<HTMLInputElement>document.getElementById('txtDate'));
      ele.value = moment(this.f.txtDate.value).format("YYYY-MM-DD");
    }
  }

  AddAccount(Account) {
    if (Account) {
      this.mdlAccount = Account;
      this.mdlAccountId = this.mdlPreviousAccountId;
      this.mdlPreviousAccount = this.mdlAccount;
      this.mdlPreviousAccountId = this.mdlAccountId;
    }
  }

  AccountSelection_Click() {
    document.getElementById("AccountSelectionBtn").click();
  }

  ModelClsBtn() {
    setTimeout(() => {
      this.themeWrapper.classList.add("modal-open");
    }, 500);
  }

  selectAccountEvent(event) {
    this.tempSelecteAccount = event.Account;
    this.tempSelecteAccountID = event.AccountID;
    this.AccountSelectList = event.Account;

  }


  SelectAccount_BtnClick(autocomplete) {
    this.AccountSelectList = "";
    if (this.tempSelecteAccount != "" && this.tempSelecteAccountID != "") {
      this.mdlAccount = this.tempSelecteAccount;
      this.mdlAccountId = this.tempSelecteAccountID;
      this.tempSelecteAccount = "";
      this.tempSelecteAccountID = "";
    }
    document.getElementById("AccountSelectionBtn").click();
    setTimeout(() => {
      this.themeWrapper.classList.add("modal-open");
    }, 500);

  }

  CalculateCost(value) {
    if (value > 0) {
      this.mdlTotalCost = (this.mdlDurationValue * value).toFixed(2);
    }
    else {
      this.mdlTotalCost = 0;
    }
  }

  emitValue(e) {
    debugger;

    let minutes = this.DateTimeToMinutes(this.f.txtTime.value);
    this.mdlDurationValue = minutes;
    if (minutes > 1) {

      minutes = minutes + " minutes";
    }
    else {
      minutes = minutes + " minute";
    }
    //this.f.txtComment.setValue(minutes);  
    //this.allocatedCallForm.controls['txtTime'].setValue('10:20');
    // this.allocatedCallForm.patchValue({
    //   txtTime: '10:20',     
    // });

    //this.allocatedCallForm.patchValue({"txtTime": '10:20 PM'});

    this.CalculateCost(this.mdlRate);


  }

  Datetimechange() {
    debugger;

    var Hours = this.f.ddlHours.value;
    var Minute = this.f.ddlMinute.value;
    if (Hours != '' && Minute != '') {
      var minutes = this.DateTimeToMinutesnew(Hours, Minute);
      this.mdlDurationValue = Number(minutes);
      // if (minutes > 1) {

      //   minutes = minutes.toString() + " minutes";
      // }
      // else {
      //   minutes = minutes.toString() + " minute";
      // }


      this.CalculateCost(this.mdlRate);
    }

  }

  DateTimeToMinutes(time) {
    var hours = (new Date(time)).getHours() * 60;
    var minutes = (new Date(time)).getMinutes();
    time = hours + minutes;
    console.log(time);
    return time;
  }

  DateTimeToMinutesnew(hours, minute) {
    var hourmenute = Number(hours) * 60;
    // var minutes = (new Date(time)).getMinutes();
    let time = Number(hourmenute) + Number(minute);
    console.log(time);
    return time;
  }

  ClearData() {
    this.allocatedCallForm.reset();

  }

}
